import React from 'react';
import i18n, { getDateFormatOptions } from '@/utils/i18n';

type StatusHistoryType = {
  status: string;
  updated_at: string;
};

type OrderHistoryProps = {
  order: {
    status_history: StatusHistoryType[];
  };
};

export default function OrderHistory({ order }: OrderHistoryProps) {
  return (
    <>
      <br />
      <table className="table-sm table" style={{ maxWidth: '600px' }}>
        <thead>
          <tr>
            <th>{i18n.t('Common:status')}</th>
            <th>{i18n.t('Common:time')}</th>
          </tr>
        </thead>
        <tbody>
          {order &&
            order.status_history.map((statusMoment) => (
              <tr>
                <td title={statusMoment.status}>
                  {i18n.t(`Order:Status:${statusMoment.status}`)}
                </td>
                <td>
                  {new Date(statusMoment.updated_at).toLocaleDateString(
                    i18n.language,
                    getDateFormatOptions(true),
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
}
